/* eslint-disable react/prop-types */
import React from 'react';

const Input = ({
  name,
  note,
  type,
  error,
  label,
  value,
  touched,
  required,
  disabled,
  className,
  handleBlur,
  handleFocus,
  placeholder,
  errorMessage,
  handleChange,
}) => (
  <>
    <div className={`form-outline mb-4 DashBoardInputBx${className ? ` ${className}` : ''}`}>
      <label id={name} className='form-label' htmlFor={name}>
        {label}
        {required && <span className='RedStar'>*</span>}
      </label>
      <input
        name={name}
        value={value}
        disabled={disabled}
        onBlur={handleBlur}
        onFocus={handleFocus}
        type={type || 'text'}
        onChange={handleChange}
        placeholder={placeholder}
        className={`form-control ${touched && error && 'input-error'}`}
      />
      {
        note && (
          <div id='emailHelp' className='form-text'>
            {note}
          </div>
        )
      }
      {
        touched && error && (
          <div className='text-danger'>{errorMessage}</div>
        )
      }
    </div>
  </>
);

export default Input;
